module.exports = __webpack_public_path__ + "img/main04.4955d07f.png";